import React from 'react';
import { Box, Typography } from '@mui/material';

interface QueryEmptyStateProps {
  title?: string;
  description?: string;
  minHeight?: number | string;
}

const QueryEmptyState: React.FC<QueryEmptyStateProps> = ({
  title = 'No data found',
  description,
  minHeight = 220,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={1}
      minHeight={minHeight}
      width="100%"
      textAlign="center"
      px={2}
    >
      <Typography variant="h6" color="text.secondary">
        {title}
      </Typography>
      {description ? (
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      ) : null}
    </Box>
  );
};

export default QueryEmptyState;
